var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-button-component" },
    [
      _c(
        "VDialog",
        {
          attrs: { maxWidth: "30%" },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _c(
            "VCard",
            [
              _c("VCardTitle", { staticClass: "headline pb-0" }, [
                _c("b", [_vm._v("Send Inquiry")])
              ]),
              _vm._v(" "),
              _c(
                "VCardText",
                [
                  _c("p", { staticClass: "subheading" }, [
                    _c("b", [_vm._v("Hi " + _vm._s(_vm.user.username))]),
                    _vm._v("! "),
                    _c("br"),
                    _vm._v(
                      "Thank you for your interest on PM2 Enterprise. To know more about our offer,\n          please reach out to us with this contact form. We will then come back to you shortly."
                    ),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _c("h2", { staticClass: "pb-2" }, [_vm._v("Contact form")]),
                  _vm._v(" "),
                  _c(
                    "VForm",
                    {
                      ref: "form",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c("VTextField", {
                        attrs: {
                          label: "Email",
                          type: "email",
                          rules: _vm.emailRules
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      }),
                      _vm._v(" "),
                      _c("VTextField", {
                        attrs: { label: "Full Name", rules: _vm.nameRules },
                        model: {
                          value: _vm.fullname,
                          callback: function($$v) {
                            _vm.fullname = $$v
                          },
                          expression: "fullname"
                        }
                      }),
                      _vm._v(" "),
                      _c("VTextField", {
                        attrs: { label: "Phone number", type: "phone" },
                        model: {
                          value: _vm.phone,
                          callback: function($$v) {
                            _vm.phone = $$v
                          },
                          expression: "phone"
                        }
                      }),
                      _vm._v(" "),
                      _c("VTextField", {
                        attrs: {
                          label: "Process Monitored",
                          type: "number",
                          hint:
                            "Number of individual processes/instances of Node.js you plan to monitor."
                        },
                        model: {
                          value: _vm.processes,
                          callback: function($$v) {
                            _vm.processes = $$v
                          },
                          expression: "processes"
                        }
                      }),
                      _vm._v(" "),
                      _c("VTextarea", {
                        attrs: {
                          required: "",
                          placeholder: "Type your comment here",
                          name: "input-7-1",
                          label: "A little bit more about your usecase"
                        },
                        model: {
                          value: _vm.comments,
                          callback: function($$v) {
                            _vm.comments = $$v
                          },
                          expression: "comments"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Center",
                [
                  _c(
                    "VBtn",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        color: "success darken-1",
                        disabled: !_vm.valid
                      },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("\n          Send Inquiry\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "VBtn",
            {
              staticClass: "contact-button font-bold ma-0",
              attrs: { color: _vm.color, small: _vm.small },
              on: {
                click: function($event) {
                  _vm.showModal = true
                }
              }
            },
            [
              !_vm.small
                ? _c("VIcon", { staticClass: "mr-2" }, [
                    _vm._v("\n        mdi-email-outline\n      ")
                  ])
                : _vm._e(),
              _vm._v("\n      Contact us\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }